import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React, { useContext } from 'react'

import { formatPlaceTypePermission } from '../../../utils/helpers/placeTypes'
import { useNavigation } from '../../../utils/contexts/NavigationContext'

export const PlaceTypeContext = React.createContext({})
export const PlaceTypeProvider = PlaceTypeContext.Provider

export const usePlaceType = () => useContext(PlaceTypeContext)

export const useTypeNavigation = namespace => {
  const type = usePlaceType()
  const navigate = useNavigation()
  return path => {
    navigate(`/places/${type}${path}`)
  }
}

export const useTypePermission = permission => {
  const type = usePlaceType()
  return useSessionPermission(getTypePermission(type, permission))
}

export const useTypeTranslation = namespace => {
  const type = usePlaceType()
  const { t } = useTranslation(namespace)
  return { t: (key, options = {}) => t(key, { context: type, ...options }) }
}

export const getPlaceIcon = placeType => {
  switch (placeType) {
    case 'fleet':
      return 'RiBus2Line'
    case 'person':
      return 'RiGroup2Line'
    default:
      return 'RiMapPinLine'
  }
}

const getTypePermission = (placeType, name) => {
  return name + formatPlaceTypePermission(placeType)
}
